import React, { useEffect, useState } from "react";
import api from "../api";

const STATUS_STYLE = {
  used: "text-[#3DDC97] border-[#3DDC97]/40",
  active: "text-[#00C3FF] border-[#00C3FF]/40",
  expired: "text-[#5C657A] border-white/10",
};
const fmtDate = (s) => (s && !s.startsWith("skipped") ? new Date(s).toLocaleDateString() : "—");

function Stat({ label, value, testid }) {
  return (
    <div className="bg-[#0C0C12] p-4">
      <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#5C657A]">{label}</div>
      <div data-testid={testid} className="font-mono-tech text-xl text-white mt-1">{value}</div>
    </div>
  );
}

export default function ThankYouCodeReport() {
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/admin/thank-you-codes").then(({ data }) => setData(data)).catch(() => setData({ summary: {}, codes: [] })); }, []);
  if (!data) return <div className="text-[#5C657A] text-sm mt-10">Loading thank-you code report…</div>;
  const s = data.summary;
  const rows = data.codes.filter((r) => filter === "all" || r.status === filter);

  return (
    <div data-testid="thank-you-code-report" className="mt-12 pt-8 border-t border-white/10">
      <div className="overline mb-4">THANK-YOU CODES · REPORT</div>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-px bg-white/10 border border-white/10 mb-6">
        <Stat label="Sent" value={s.sent || 0} testid="ty-stat-sent" />
        <Stat label="Used" value={s.used || 0} testid="ty-stat-used" />
        <Stat label="Active" value={s.active || 0} testid="ty-stat-active" />
        <Stat label="Expired" value={s.expired || 0} testid="ty-stat-expired" />
        <Stat label="Redemption" value={`${s.redemption_rate || 0}%`} testid="ty-stat-rate" />
        <Stat label="Repeat Revenue" value={`$${Number(s.repeat_revenue || 0).toFixed(2)}`} testid="ty-stat-revenue" />
      </div>
      <div className="flex gap-2 mb-4">
        {["all", "used", "active", "expired"].map((f) => (
          <button key={f} data-testid={`ty-filter-${f}`} onClick={() => setFilter(f)}
            className={`px-3 py-1.5 border font-mono-tech text-[10px] uppercase tracking-[0.2em] transition-colors ${filter === f ? "border-[#00C3FF] text-[#00C3FF]" : "border-white/10 text-[#8A94A6] hover:text-white"}`}>
            {f}
          </button>
        ))}
      </div>
      <div className="overflow-x-auto border border-white/10">
        <table className="w-full text-xs min-w-[760px]">
          <thead>
            <tr className="text-left font-mono-tech text-[10px] uppercase tracking-[0.18em] text-[#5C657A] border-b border-white/10">
              {["Code", "Customer", "From order", "Sent", "Expires", "Reminder", "Status", "Used on", "Order total"].map((h) => <th key={h} className="p-3 font-normal">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={9} data-testid="ty-empty" className="p-6 text-center text-[#5C657A]">No codes yet. They're issued 12 hours after each paid order.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.code} data-testid={`ty-row-${r.code}`} className="border-b border-white/5">
                <td className="p-3 font-mono-tech text-white">{r.code}</td>
                <td className="p-3 text-[#8A94A6]">{r.email}</td>
                <td className="p-3 font-mono-tech">{r.source_order || "—"}</td>
                <td className="p-3">{fmtDate(r.sent_at)}</td>
                <td className="p-3">{fmtDate(r.expires_at)}</td>
                <td className="p-3">{fmtDate(r.reminder_sent_at)}</td>
                <td className="p-3"><span className={`px-2 py-0.5 border font-mono-tech text-[10px] uppercase ${STATUS_STYLE[r.status]}`}>{r.status}</span></td>
                <td className="p-3 font-mono-tech">{r.used_on_order || "—"}</td>
                <td className="p-3 font-mono-tech">{r.used_order_total ? `$${r.used_order_total.toFixed(2)}` : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
